import LogoLoading from "components/LogoLoading";
import { useAppContext } from "contexts/AppContext";
import useAuth from "hooks/useAuth";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FastLogin from "./FastLogin";
import axiosClient from "utils/axios";

const LOCAL_STORAGE_AF_CHECK_INTERVAL = 100; // 0.1 second
const AUTH_CHECK_INTERVAL = 60 * 1000; // 60 seconds

const AuthGaurd = ({ children }) => {
  // contexts
  const { appState } = useAppContext();

  // states
  const [forward, setForward] = useState(false);
  const [fastLogin, setFastLogin] = useState(false);

  //hooks
  const { loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // effects
  useEffect(() => {
    // checks _af key in local storage
    // if _af is 1, user is not authenticated
    // and the login modal shows up
    // by default every 100ms
    const authChecker = setInterval(() => {
      const _af = localStorage.getItem("_af");
      if (_af === "1") {
        localStorage.setItem("_af", 0);
        setFastLogin(true);
      }
    }, LOCAL_STORAGE_AF_CHECK_INTERVAL);

    return () => {
      clearInterval(authChecker);
    };
  }, []);

  useEffect(() => {
    isAuthenticated();
  }, []);

  useEffect(() => {
    // checks authentication status of user.
    // if not authenticated, it shows login modal
    // by default every 60s

    // Don't query if fast login is already shown to user
    if (fastLogin === true) return;

    const standaloneAuthChecker = setInterval(() => {
      axiosClient
        .get(`${import.meta.env.VITE_API}/auth-check/?t=${Date.now()}`)
        .then((res) => {
          setFastLogin(!res.data.authenticated);
        });
    }, AUTH_CHECK_INTERVAL);

    return () => {
      clearInterval(standaloneAuthChecker);
    };
  }, [fastLogin]);

  useEffect(() => {
    if (!loading) {
      if (appState.auth?.isAuthenticated === true) setForward(true);
      else if (appState.auth && !appState.auth.isAuthenticated)
        navigate("/auth/login?redirect=" + location.pathname + location.search);
    }
  }, [loading, appState]);

  return (
    <React.Fragment>
      {!forward && <LogoLoading text="Authenticating..." />}
      {forward && <React.Fragment>{children}</React.Fragment>}
      {fastLogin && <FastLogin setFastLogin={setFastLogin} />}
    </React.Fragment>
  );
};

export default AuthGaurd;
